// Auth store entryfile
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

// Initial state
const state = {
  menuItems: [],
  activeWebsite: null,
  reloadEmail: true,
  reloadCertificate: true,
};

export default {
  actions,
  mutations,
  getters,
  state,
};
